import { COMPANY_NAME, COMPANY_NAME_FC } from 'config/company.constants'

export const hardCodedEmailList: Record<string, string> = {
  'user.fundDrawRequestReceived': 'Fund Draw Request Received',
  'user.accountExecuiveContact': 'Account Executive Contact Notification',
  'user.2faAuthCode': '2FA Authentication with code',
  'user.passwordReset': 'User Password Reset',
  'user.contactUs': 'Contact Us',
  'loan.borrowerDocumentsExpiring': 'Borrower Documents are expiring notification',
  'loan.automatedLoanReport': 'Automated Loan Report - (Scheduled reports)',
  'loan.contractorBuilderApplicationUpdate': 'Contractor / Builder Application Update - ',
  'loan.contractorBuilderApprovalInvitation': 'Contractor / Builder Approval Invitation - ',
  'loan.contractorBuilderApplicationApproved': 'Contractor / Builder Application has been approved - ',
  'loan.creditAuthorizationSignRequest': 'Credit Authorization sign request for Loan, ',
  'loan.documentSignRequest': 'Document sign request for Your Loan, ',
  'loan.drawRequest': 'Draw request for Your Loan, ',
  'loan.mldsSignRequest': 'MLDS sign request for Your Loan, ',
  'loan.fundDrawRequest': 'Fund Draw Request',
  'loan.withdrawnDeclinedLoansWeeklyReports': 'Withdrawn/Declined Loans weekly reports',
  'loan.paymentForLoanSetupInstructions': 'Payment for Loan Setup Instructions - ',
  'loan.scenarioSharing': 'Loan Scenario Sharing',
  'loan.lockPricingConfirmation': 'Lock Pricing Confirmation',
  'loan.newLoanCreated': 'A new loan has been created',
  'task.notification': 'Task Notification',
  'task.completed': 'Loan# #LoanNumber - #Address - Task #TaskNo Completed',
  'user.paymentForCounterpartyApproval': 'Payment for Counterparty Approval',
  'user.investedLoanMessage': 'Invested Loan Message',
  'user.investorAccountCreated': 'Your Investor Account has been created',
  'user.welcomeToInvestorPortal': `Welcome to your "${COMPANY_NAME}" Investor Portal (Investor)`,
  'user.participantAccountCreated': 'Your Participant Account has been created',
  'user.welcomeToParticipantPortal': `Welcome to your "${COMPANY_NAME}" Participant Portal`,
  'user.welcomeToBorrowerPortal': `Welcome to your "${COMPANY_NAME_FC}" Borrower Portal`,
  'user.accountCreated': 'User Account Created',
  'user.newBrokerRegistration': 'New Broker Registration',
  'user.sentLoginLink': 'Sent Login Link with New Password',
  'shared.dataVerifyStatusUpdated': 'DataVerify Status is updated for ',
  'shared.addCommentNotification':
    'Add Comment Notification (Elite valuation) this is sent to Only orders@elitevals.com',
  'shared.trinityOrderValuationNotification': 'Trinity Order Valuation Notification',
  'shared.visionVMCInvoice': 'Vision VMC Invoice #LoanNumber - #InvoiceNumber',
}
